
import { createContext, useState, useContext, ReactNode } from 'react';
import { Product } from '@/types';

interface ProductContextType {
  products: Product[];
  setProducts: (products: Product[]) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  selectedProduct: Product | null;
  setSelectedProduct: (product: Product | null) => void;
  isAddSheetOpen: boolean;
  setIsAddSheetOpen: (isOpen: boolean) => void;
  isEditSheetOpen: boolean;
  setIsEditSheetOpen: (isOpen: boolean) => void;
  isDeleteDialogOpen: boolean;
  setIsDeleteDialogOpen: (isOpen: boolean) => void;
}

export const ProductContext = createContext<ProductContextType>({
  products: [],
  setProducts: () => {},
  isLoading: false,
  setIsLoading: () => {},
  selectedProduct: null,
  setSelectedProduct: () => {},
  isAddSheetOpen: false,
  setIsAddSheetOpen: () => {},
  isEditSheetOpen: false,
  setIsEditSheetOpen: () => {},
  isDeleteDialogOpen: false,
  setIsDeleteDialogOpen: () => {},
});

interface ProductProviderProps {
  children: ReactNode;
}

export const ProductProvider = ({ children }: ProductProviderProps) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [isAddSheetOpen, setIsAddSheetOpen] = useState(false);
  const [isEditSheetOpen, setIsEditSheetOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  return (
    <ProductContext.Provider
      value={{
        products,
        setProducts,
        isLoading,
        setIsLoading,
        selectedProduct,
        setSelectedProduct,
        isAddSheetOpen,
        setIsAddSheetOpen,
        isEditSheetOpen,
        setIsEditSheetOpen,
        isDeleteDialogOpen,
        setIsDeleteDialogOpen,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProductContext = () => useContext(ProductContext);
